import React from 'react';

// Import award images
import award1 from '../images/award/award_1.png';

const AwardsSection = () => {
  const awards = [
    {
      title: 'Presented statue of Ram Ji to Yogi Adityanath Ji',
      description: 'Honored for the exquisite craftsmanship and cultural significance of the Ram statue presented to the Chief Minister of Uttar Pradesh.',
      image: award1
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-primary-50 to-secondary-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Awards & Recognition
          </h2>
          <div className="w-24 h-1 bg-primary-500 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Celebrating artistic excellence and the impact of our work on communities and culture
          </p>
        </div>

        {/* Awards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {awards.map((award, index) => (
            <div
              key={index}
              className="award-card group relative overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              {/* Award Image */}
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={award.image}
                  alt={award.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  onError={(e) => {
                    e.target.src = '/images/placeholder.jpg';
                  }}
                />
                
                {/* Year Badge - Top Right */}
                <div className="absolute top-4 right-4 bg-primary-500 text-white px-3 py-1 rounded-full text-sm font-bold shadow-lg">
                  {award.year}
                </div>

                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              </div>

              {/* Text Content at Bottom */}
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                <h3 className="text-xl font-bold mb-2 group-hover:text-primary-300 transition-colors duration-300">
                  {award.title}
                </h3>
                
                <p className="text-primary-200 font-medium mb-2 text-sm">
                  {award.organization}
                </p>
                
                <p className="text-gray-200 text-sm leading-relaxed opacity-90">
                  {award.description}
                </p>
              </div>

              {/* Hover Effect Border */}
              <div className="absolute inset-0 border-2 border-transparent group-hover:border-primary-400 rounded-xl transition-all duration-300"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AwardsSection;